import React from 'react'
import { IconSVGType } from '../../types/icons'

/**
 * @param {IconSVGType} props
 * @param {string} props.className (Optional) - Class name of the component.
 * @param {object} props.style (Optional) - Styles to customize the look & feel of the component.
 */
const RemoveAttachmentIcon = (props: IconSVGType) => {
  return (
    <svg
      className={props.className}
      fill='none'
      height={props.height}
      viewBox={props.viewBox || '0 0 14 14'}
      width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#999'
        fillRule='evenodd'
        d='M6.991 0C10.86 0 14 3.122 14 6.991A7.012 7.012 0 0 1 6.991 14C3.122 14 0 10.86 0 6.991A6.981 6.981 0 0 1 6.991 0Zm0 6.159 1.89-1.89c.556-.556 1.406.277.85.832l-1.89 1.89 1.89 1.891c.556.555-.294 1.405-.85.85l-1.89-1.89-1.89 1.89c-.556.556-1.388-.295-.833-.85l1.89-1.89L4.268 5.1c-.555-.555.277-1.388.832-.833l1.891 1.89Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default RemoveAttachmentIcon
